/* eslint-disable import/no-unused-modules */
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const useTeamSpaceTrackingEvents = ({ selectedTab }) => {
  const trackEvent = (eventName, payload = {}) => {
    TrackingService.logEvent(eventName, {
      page: TRACKING.PAGES.ITERATIONS,
      page_tab: selectedTab,
      ...payload
    });
  };

  const visit = () => trackEvent(TRACKING.EVENTS.VISIT);

  const onTabClick = newTab =>
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.TEAM_SPACE.HEADER.SELECT_TAB,
      value: newTab
    });

  const onTeamChange = teamId =>
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.TEAM_SPACE.HEADER.SELECT_TEAM,
      value: teamId
    });

  const onIterationChange = iterationId =>
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.TEAM_SPACE.HEADER.SELECT_ITERATION,
      value: iterationId
    });

  const onTrendDurationChange = trendDurationKey =>
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.TEAM_SPACE.HEADER.SELECT_TREND_DURATION,
      value: trendDurationKey
    });

  const onViewIterationActivity = () =>
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.TEAM_SPACE.HEADER.VIEW_ITERATION_ACTIVITY
    });

  return {
    visit,
    onTabClick,
    onTeamChange,
    onIterationChange,
    onTrendDurationChange,
    onViewIterationActivity
  };
};

export default useTeamSpaceTrackingEvents;
